module.exports = __webpack_public_path__ + "img/4-1.2f55f491.svg";